<template>
  <div class="wrap" :class="{addPadding}">
    <car-headerbar :title="query.edit || query.templateSetting ? '查看范围设置' : '发送范围设置'" :isCustomLeft="isCustomLeft"/>
    <!-- <header-back :title="query.edit ? '查看范围设置' : '发送范围设置'" @back="headerBackFn"></header-back> -->
        <div>
            <div class="warp_list">
                <div class="list_item" v-for="(item, index) in listData" :key="index" @click="addSendRange(item, 'update')">
                    <div class="item_flex">
                        <div class="flex_label">{{`方案${index + 1}`}}</div>
                        <div class="flex_value" @click.stop="removeSendRangeItem(item, index)" v-if="!query.readonly">
                            <img src="https://image-pub.guazistatic.com/qnbdp1066xe79fa11add8d4c77be4b04bfffb86fdd1723195728.png" alt="">
                        </div>
                    </div>
                    <div class="item_flex">
                        <div class="flex_label">{{"类型"}}</div>
                        <div class="flex_value">
                            {{item.sendType === 'dept' ? '部门' : item.sendType === 'user' ? '人员' : '职级'}}
                        </div>
                    </div>
                    <div class="item_flex">
                        <div class="flex_label">{{"范围"}}</div>
                        <div class="flex_value">
                            <div class="flex_value_overflow">{{item.rangeContent}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="add_send">
                <div class="add_send_text" @click="addSendRange" v-if="listData.length < 3 && !query.readonly">+ {{query.edit || query.templateSetting ? '添加查看范围' : '添加发送范围'}}</div>
            </div>
        </div>
        <confirm @confirm="confirm"/>
  </div>
</template>

<script>
import confirm from '../compontents/confirm.vue'
import { Questionnaire } from '@/network'
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import browser from '@/util/browser'
import debounce from '@/util/debounce'
import { addClass2, removeClass2 } from '@/util/status-util'


export default {
    data() {
        return {
            addPadding: false,
            listData: [],
            updateRange: '0',
            isCustomLeft: false
        }
    },
    mixins: [mixin],
    created() {
        if (this.query.updateRange) {
            this.updateRange = '1'
        }
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.listData = this.$store.state.rangeList || []
        removeClass2('body', 'loading')
    },
    mounted() {
        if (this.query.readonly) {
            this.getAuthority()
        }
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        query() {
            return this.$route.query
        }
    },
    components: {
        confirm,
    },
    methods: {
        // headerBackFn() {
        //     this.updateRange = '0'
        //     this.confirm()
        // },
        confirm() {
            if (this.query.readonly) {
                this.$router.back()
                return
            }
            let query = {
                updateRange: this.updateRange
            }
            let name = 'publish'
            if (this.query.edit) {
                name = 'edit'
            } else if (this.query.templateSetting) {
                name = 'templateSetting'
                query.updateLabel = this.query.updateLabel
            } else {
                name = 'publish'
            }
            this.$router.replace({
                name,
                params: {
                    pageId: this.pageId
                },
                query
            })
        },
        addSendRange(data, type) {
            if (this.query.readonly) {
                return
            }
            let query = {
                sendType: data.sendType,
            }
            if (type && type === 'update') {
                query.update = 'update'
            }
            if (this.query.edit) {
                query.edit = this.query.edit
            }
            if (this.query.templateSetting) {
                query.templateSetting = this.query.templateSetting
                query.updateLabel = this.query.updateLabel
            }
            this.$router.push({
                name: 'sendingRangeSetting',
                params: {
                    pageId: this.pageId
                },
                query,
            })
        },
        removeSendRangeItem(item, index) {
            if (this.query.readonly) {
                return
            }
            this.listData.splice(index, 1)
            this.$store.commit('saveRangeList', this.listData)
            this.updateRange = '1'
        },
        getAuthority() {
            addClass2('body', 'loading')
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.getAuthority(data).then((res) => {
                const { code, data } = res.data
                removeClass2('body', 'loading')
                if (code == 'S00000') {
                    this.listData = data
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
    },

   
}
</script>
<style lang="scss" scoped>
    .addPadding {
        padding-bottom: 400PX!important;
    }
    .wrap{
        position: relative;
        // background: #F2F4F6;
        height: 100%;
        .warp_list {
            width: 100%;
            .list_item {
                margin: 10px 0px;
                padding: 15px;
                font-size: 14px;
                background: #fff;
                .item_flex {
                    padding: 10px 0px;
                    display: flex;
                    justify-content: space-between;
                }
                .flex_label {
                    flex: 1;
                }
                .flex_value {
                    // text-align: right;
                    flex: 3;
                    display: flex;
                    justify-content: flex-end;
                    img {
                        cursor: pointer;
                        width: 20px;
                    }
                }
                .flex_value_overflow {
                    overflow: hidden;
                    text-overflow: ellipsis; // 溢出显示省略号
                    display: -webkit-box;  // 弹性盒子
                    -webkit-box-orient: vertical; // 上下垂直排列
                    -webkit-line-clamp: 4; // 显示行数（数字可调整）
                }
            }
        }
        .add_send {
            margin: 15PX 10PX;
            background: #fff;
            cursor: pointer;
            .add_send_text {
                font-size: 14px;
                color: #06B455;
                text-align: center;
                padding: 10px 0px;
            }
        }

    }

</style>
